import moment from "moment"

  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
    playSound('/oee-error.mp3');
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function buildBreadcrumb(routeName, routePath, pId, title, menu, paths) {
    let breadcrumbs = [];
    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: item.title,
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, title, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: item.title,
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: title || `${child.title} (#${pId})`,
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

 export function clearVietnamese(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  return str;
}

export function playSound(sound) {
  if (!sound) {
    console.warn("playSoundSequential: Input sound string is empty.");
    return;
  }

  // Tách chuỗi và lọc bỏ các phần tử rỗng (nếu có dấu phẩy thừa)
  const files = sound.split(',').map(file => file.trim()).filter(file => file.length > 0);

  if (files.length === 0) {
    console.warn("playSoundSequential: No valid sound files found after splitting.");
    return;
  }

  let currentIndex = 0;
  // Tạo một đối tượng Audio duy nhất để tái sử dụng
  const audioPlayer = new Audio();

  function playNextFile() {
    // Điều kiện dừng: Nếu đã phát hết tất cả các file
    if (currentIndex >= files.length) {
      console.log("Finished playing all sounds.");
      // Optional: bạn có thể thêm hành động gì đó ở đây khi phát xong
      return;
    }

    const fileToPlay = files[currentIndex];
    console.log(`Playing sound ${currentIndex + 1}/${files.length}: ${fileToPlay}`);
    audioPlayer.src = fileToPlay;

    // Xử lý lỗi tiềm ẩn khi load hoặc play file
    audioPlayer.play().catch(error => {
      console.error(`Error playing ${fileToPlay}:`, error);
      // Quyết định: Bỏ qua file lỗi và phát file tiếp theo
      currentIndex++;
      playNextFile();
    });
  }

  // Gắn sự kiện 'ended' MỘT LẦN cho audioPlayer
  // Khi một file phát xong, tăng index và gọi hàm để phát file tiếp theo
  audioPlayer.onended = () => {
    currentIndex++;
    playNextFile();
  };

  // Bắt đầu phát file đầu tiên
  playNextFile();
}

export function isValidJson(json) {
  try {
    JSON.parse(json);
    return true;
  } catch (e) {
    return false;
  }
}

export function proxyImage(imageUrl) {
  if (!imageUrl) {
      return ''
  };
  
  // Nếu ảnh đã là từ domain local thì không cần proxy
  if (process.env.NODE_ENV === "development" || imageUrl.startsWith('/') || imageUrl.includes(window.location.hostname) || imageUrl.includes('firebase')) {
      return imageUrl;
  }
  
  // format image URL để sử dung với img-proxy theo dạng https://dash.phanmemdathangoee.com/img-proxy/cbu01.alicdn.com/img/ibank/O1CN01xGElTx2BF7YwXZBaP_!!2219614988308-0-cib.jpg
  // return `https://images.weserv.nl/?url=${imageUrl}`;
  return `https://image-proxy.mamdtech.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
}